module.exports = __webpack_public_path__ + "static/media/Qworky_Banner.e3ac957c.jpg";